import { card } from './card';
import { chip } from './chip';
import { link } from './link';
import { form } from './form';
import { table } from './table';
import { radio } from './radio';
import { dialog } from './dialog';
import { drawer } from './drawer';
import { select } from './select';
import { button } from './button';
import { svgIcon } from './svg-icon';
import { progress } from './progress';
import { checkbox } from './checkbox';
import { textfield } from './textfield';
import { typography } from './typography';
import { breadcrumbs } from './breadcrumbs';
import { autocomplete } from './autocomplete';
import { datePicker } from './mui-x-date-picker';

export const components = {
  ...card,
  ...link,
  ...form,
  ...chip,
  ...table,
  ...alert,
  ...radio,
  ...dialog,
  ...drawer,
  ...select,
  ...button,
  ...svgIcon,
  ...progress,
  ...checkbox,
  ...textfield,
  ...typography,
  ...datePicker,
  ...breadcrumbs,
  ...autocomplete,
};
